import clsx from "clsx";
import LinkComponent from "../LinkComponent";
import * as styles from "./styles.module.scss";

export const socials = {
  linkedin: <img src="/svgs/linkedin.svg" alt="LinkedIn" data-svg="true" />,
};

interface Props {
  url: string;
  children?: React.ReactNode;
  type: keyof typeof socials;
  className?: string;
}

const SocialLink = ({ url, children, type, className }: Props) => {
  return (
    <LinkComponent
      className={clsx(styles.socialLink, className)}
      url={url}
      type="external"
    >
      {socials[type] || children}
    </LinkComponent>
  );
};

export default SocialLink;
